import { VIDEO } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import VideoEditDrawer from './video-edit-drawer';
import { EditProps } from './video.constants';

const VideoSettings = (props: EditProps) => {
  return props.properties.stimulusId ? (
    <VideoEditDrawer {...props} />
  ) : (
    <StimulusLibrary
      title="Video"
      stimulusType={VIDEO}
      componentId={props.id}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={VIDEO}
        />
      }
      {...props}
    />
  );
};

export default VideoSettings;
